module.exports = __webpack_public_path__ + "static/media/jj-help3.bcded274.png";